import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { createReduxStore } from "./redux/pageStore";
import ModulesRenderer from "./modulesRenderer";
import { Provider as RollbarProvider } from "@rollbar/react";
import { TrackingContext } from "../tracking/TrackingContext";

const PageWithConfigurator = ({ pageConfig, notifications, renderFilters, renderAI }) => {
  const { pageName, moduleList, pageFilters = [] } = pageConfig;

  const modules = [...moduleList, ...pageFilters].map(({ moduleName, saga, reducer }) => ({
    moduleName,
    saga,
    reducer
  }));

  const store = createReduxStore(pageName, modules);

  // Filter tracking only fires in qa/production; backend also guards, so this gates the dev/test noise.
  const trackingEnabled = ["qa", "production"].includes(notifications.env);

  return (
    <RollbarProvider
      config={{
        accessToken: notifications.rollbar,
        environment: notifications.env,
        payload: {
          context: pageName
        },
        enabled: notifications.env !== "development",
        captureUncaught: false,
        captureUnhandledRejections: false
      }}
    >
      <ReduxProvider store={store}>
        {/* Provides page_name to filter tracking (Mixpanel) for all nested filters. */}
        <TrackingContext.Provider value={{ pageName, enabled: trackingEnabled }}>
          <ModulesRenderer
            pageConfig={pageConfig}
            renderFilters={renderFilters}
            renderAI={renderAI}
          />
        </TrackingContext.Provider>
      </ReduxProvider>
    </RollbarProvider>
  );
};

export default PageWithConfigurator;
